// Detailed interpretation availability indicator — marks Patterns that carry
// the published Durable Interpretation layer (interpretation != null
// upstream). Pure availability signal: never implies higher score,
// reliability or importance.
import React from "react";
import { BookOpen } from "lucide-react";
import InfoTip from "./InfoTip";

const TIP_TEXT = "Additional detailed qualitative interpretation is available for this Pattern — what it is, scope, stakeholder implications and watchpoints. Availability does not change the Pattern's score, ranking or reliability.";

export const DeepInsightBadge = ({ testId }) => (
    <span className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full border border-[hsl(var(--line))] bg-[hsl(var(--surface-sunken))]/60 text-[9.5px] font-medium text-[hsl(var(--ink-soft))] whitespace-nowrap"
          data-testid={testId || "wp13-deep-insight-badge"}>
        <BookOpen size={10} strokeWidth={1.8} />
        Detailed interpretation
        <InfoTip label="Detailed interpretation" testId={`${testId || "wp13-deep-insight-badge"}-tip`}>{TIP_TEXT}</InfoTip>
    </span>
);

export const DeepInsightDot = ({ testId }) => (
    <span className="inline-flex items-center text-[hsl(var(--mute))]" title={`Detailed interpretation available. ${TIP_TEXT}`}
          data-testid={testId || "wp13-deep-insight-dot"} aria-label="Detailed interpretation available">
        <BookOpen size={11} strokeWidth={1.8} />
    </span>
);
